import axios from 'axios'

import { tokenManager } from '@/stores/user'

export const http = axios.create({
  baseURL: `${import.meta.env.VITE_PUBLIC_GATA_SERVER_HOST}/api`,
})

export const getNonce = async (address: string) => {
  const res = await http.post('/signature_nonce', { address })

  if (res.status === 200) {
    return res.data
  }
}

export const authNonce = async (address: string, signature: string) => {
  const res = await http.post('/authorize', {
    public_address: address,
    signature_code: signature,
    invite_code: '',
  })
  return res.data
}

/**
 *
 * @param type 0: Chat, 1: Task, 2: Turnstile, 4 decloud
 * @returns
 */
export async function grantToken(type: number) {
  const token: string = tokenManager.getGataToken()
  if (!token) {
    return
  }
  const res = await http.post(
    '/grant',
    {
      type,
      site_token: null,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  )
  return res.data
}

export async function paymentRequest(amount: number) {
  const token: string = tokenManager.getGataToken()
  if (!token) {
    return
  }
  const res = await http.post(
    '/payment_request',
    {
      amount,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  )
  return res.data
}
